import { defineComponent as _defineComponent } from 'vue'
import { mdiArrowRight } from '@mdi/js';
	import { VIcon } from 'vuetify/lib/components';

export default /*#__PURE__*/_defineComponent({
  __name: 'sub-section',
  setup(__props) {

	
return { __sfc: true,mdiArrowRight, VIcon }
}

})